export default { lat: -0.1235425, lng: -78.4827779 };